import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const TEXTURE =
  "https://images.unsplash.com/photo-1579492450119-80542d516179?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwY29uY3JldGUlMjB3YWxsJTIwdGV4dHVyZSUyMHNoYWRvdyUyMGRlc2F0dXJhdGVkfGVufDB8fHx8MTc5Mjk3MDk2OXww&ixlib=rb-4.1.0&q=85";

export default function CtaBand() {
  return (
    <section data-testid="cta-band" className="relative overflow-hidden border-t border-[#F7F5F1]/10 py-28 sm:py-36">
      <img
        src={TEXTURE}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover opacity-25"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#26282E]/70 via-[#2E3038]/55 to-[#26282E]" />
      <div className="relative mx-auto max-w-4xl px-6 text-center sm:px-8">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#E3D9C8]">Begin the Conversation</p>
          <h2 className="mt-7 font-serif text-4xl leading-[1.1] tracking-tight text-[#F7F5F1] sm:text-5xl lg:text-6xl">
            Your next high-stakes moment deserves your most <em className="text-[#E3D9C8]">credible</em> voice.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mx-auto mt-8 max-w-xl text-base leading-relaxed text-[#C4BFB4] sm:text-lg">
            All inquiries are confidential. This is not a sales call; it is a focused conversation about whether
            coaching is the right fit.
          </p>
        </Reveal>
        <Reveal delay={0.22}>
          <Link
            to="/contact"
            data-testid="cta-band-button"
            className="group mt-12 inline-flex items-center gap-3 rounded-md bg-[#2F5D8C] px-8 py-4 font-mono text-[11px] uppercase tracking-[0.22em] text-[#F7F5F1] transition-colors duration-300 hover:bg-[#254A6E]"
          >
            Request a Confidential Consultation
            <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
